import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";

const SkorProtectBadge = () => {
  const { _t } = useTranslator();

  return (
    <span className="sp-badge-pill">
      <img src={SkorProtectShield} alt="" className="sp-shield" />
      <span className="sp-badge-pill-text">{_t("skorProtectTitle")}</span>
    </span>
  );
};

export default SkorProtectBadge;
